import createReactClass from "create-react-class";
import React from "react";
export default createReactClass({
  displayName: "Root",
  getInitialState() {
    return {
      necessariesItem: this.props.necessariesItem,
    };
  },
  onError() {
    var updated = this.state.necessariesItem;
    updated.thumbnail_image_url = "/images/ja2/img_noimage.gif";
    this.setState({
      necessariesItem: updated,
    });
  },
  render() {
    var timeAgo = this.state.necessariesItem.created_at_time_ago_format;
    var backgroundColor = "";
    if (this.state.necessariesItem.is_read) {
      backgroundColor = "#ffffff";
    } else {
      backgroundColor = "#f1f1f1";
    }
    return (
      <div>
        <a
          href={this.props.necessariesItem.url}
          id="necessaries-item"
          className="necessaries"
        >
          <li>
            <div
              className="row justify-content-around align-items-center pt-1 pb-1 border-bottom"
              style={{ backgroundColor: backgroundColor }}
            >
              <div className="col-2 pr-1">
                <img
                  src={this.state.necessariesItem.thumbnail_image_url}
                  onError={this.onError}
                  className="rounded-circle member-icon_48px"
                  alt=""
                />
              </div>
              <div className="col pl-3">
                <p
                  className="mb-0"
                  dangerouslySetInnerHTML={{
                    __html: this.state.necessariesItem.title,
                  }}
                  style={{ fontSize: "14px" }}
                />
                <p className="text-fz-small text-black-20 mb-0">{timeAgo}</p>
              </div>
            </div>
          </li>
        </a>
      </div>
    );
  },
});